import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Row, Col} from 'react-bootstrap'
import PageTitle from "../common/page-title/index";
import InlineCKEditor from '../common/editor/inline-editor'
import StoreList from './store-list';
import {getStaffRewardOutlets} from '../../actions/staff';
import {loadPageContent} from '../../actions/content';

import './staff-rewards.css'

class StaffRewads extends Component {
  constructor(props) {
    super(props);

    this.pageSlug = 'staff-rewards';
    this.stores = [];
  }

  componentWillMount() {
    this.props.dispatch(getStaffRewardOutlets());
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <Grid bsClass="container" className="staff-rewards">
        <Row>
          <Col lg={12}>
            <PageTitle>My Staff rewards</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor identifier={`${this.pageSlug}_content_text`}
                            onContentSaved={this.handleContentSaved}
                            contents={this.props.contents[`${this.pageSlug}_content_text`]}/>
          </Col>
        </Row>
            <StoreList
              stores={this.props.stores}
              fetching={this.props.fetching}
              fetched={this.props.fetched}
            />
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stores:   state.staff.staffRewards.stores,
    fetched:  state.staff.fetched,
    fetching: state.staff.fetching,
    contents: state.content.list
  }
};

export default connect(mapStateToProps)(StaffRewads);



// WEBPACK FOOTER //
// ./src/components/staff-rewards/index.jsx